"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useSettings } from "@workspace/gamja-platform/settings/react";

/** Keep links in payment confirmations, email and PDF details working. */
export default function LegacyPurchaseSettings({
  section,
}: {
  section: "pass" | "purchases";
}) {
  const { openSettings } = useSettings();
  const title = section === "pass" ? "감자 이용권" : "구매 목록";
  useEffect(() => {
    openSettings(section);
  }, [openSettings, section]);
  return (
    <div className="mx-auto max-w-2xl space-y-4 px-5 py-12">
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="text-sm text-muted-foreground">
        {title}은 설정에서 확인할 수 있어요.
      </p>
      <Button onClick={() => openSettings(section)}>{title} 열기</Button>
    </div>
  );
}
